module.exports = __webpack_public_path__ + "4abaf2b259044d3c1449f5ab2b2273a9.svg";